import * as _ from 'underscore'

import { OpRole } from '../../models/core'
import { OpDataList } from '../../models/util'
import { OpDistributorData } from '../../models/core/op-distributor-data'
import { Enums } from '../../models/common'

import { UserSessionService, USER_SESSION_SERVICE_NAME } from '../user-session'


//#region Public Types

export const DISTRIBUTOR_ROLE_SERVICE_NAME = 'DistributorRoleService'
export const DISTRIBUTOR_ROLE_SERVICE_PROVIDER_NAME = 'DistributorRoleServiceProvider'

//#endregion


export class DistributorRoleService {

    //#region Ctor

    public constructor(private userSessionService: UserSessionService) { }

    //#endregion

    public createDistributorDataFromOpRoles(roles: OpRole[]): OpDataList<OpDistributorData> {
        const dataList: OpDataList<OpDistributorData> = new OpDataList<OpDistributorData>()

        _.forEach(roles, (role: OpRole) => {
            const assignedRole: OpDistributorData = new OpDistributorData(null)

            assignedRole.idData = 0
            assignedRole.idDataType = Enums.DataType.HELPER_DISTRIBUTOR_ID_ROLE
            assignedRole.indexNbr = 0
            assignedRole.value = role.idRole
            assignedRole.opState = Enums.OpChangeState.New

            dataList.push(assignedRole)
        })

        return dataList
    }
}

export class DistributorRoleServiceProvider implements ng.IServiceProvider {

    //#region IServiceProvider Implementation 

    public $get = [USER_SESSION_SERVICE_NAME, function (userSession: UserSessionService) {
        return new DistributorRoleService(userSession)
    }]

    //#endregion
} 